"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BOOLEAN_OPERATIONS_TO_BQ_FORMULA = exports.COMPARISON_OPERATIONS_TO_BQ_FORMULA = exports.EXP_SYMBOL_TO_BQ_FORMULA = void 0;
const antlr_files_1 = require("../antlr_files");
exports.EXP_SYMBOL_TO_BQ_FORMULA = {
    [antlr_files_1.Lexer.PLUS]: 'ADD',
    [antlr_files_1.Lexer.MINUS]: 'SUB',
    [antlr_files_1.Lexer.DIV]: 'DIV',
    [antlr_files_1.Lexer.TIMES]: 'MUL',
    [antlr_files_1.Lexer.POW]: 'POW',
};
exports.COMPARISON_OPERATIONS_TO_BQ_FORMULA = {
    '>': 'GT',
    '>=': 'GTE',
    '<': 'LT',
    '<=': 'LTE',
    '=': 'EQ',
    '==': 'EQ',
    '!=': 'NEQ',
    '<>': 'NEQ',
};
exports.BOOLEAN_OPERATIONS_TO_BQ_FORMULA = {
    '&&': 'AND',
    '||': 'OR',
};
